import { resolveCountry, LOCALE_BY_COUNTRY } from "./FormatByCountry";

const formatInputFloat = (val: any, numberOfDecimal = 2) => {
  const country = resolveCountry();
  const locale = LOCALE_BY_COUNTRY[country];
  const numberValue = Number(String(val).replace(/,/gi, "."));
  if (!val) return "0";
  return Number(numberValue.toFixed(numberOfDecimal)).toLocaleString(locale);
};
export default formatInputFloat;
